import { render, staticRenderFns } from "./companyAdvertisement.vue?vue&type=template&id=7d06b1c4&scoped=true&"
import script from "./companyAdvertisement.vue?vue&type=script&lang=js&"
export * from "./companyAdvertisement.vue?vue&type=script&lang=js&"
import style0 from "./companyAdvertisement.vue?vue&type=style&index=0&id=7d06b1c4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d06b1c4",
  null
  
)

export default component.exports